interface IRedirectToUrlWithOneTimeSidAuthLogicParams {
  /**
   * Данные, полученные из ответа запроса на телепорт.
   */
  teleportData: ITeleportData | undefined;
  /**
   * Асинхронная функция, возвращающая строку - значение для параметра nextauth.
   */
  getNewStackOneTimeSid: () => Promise<string>;
  /**
   * Pathname, который нужно добавить в URL, на который происходит редирект.
   */
  redirectionPathname?: string;
  /**
   * Query параметры, которые нужно добавить в URL, на который происходит редирект.
   */
  redirectionSearchParams?: URLSearchParams;
}

interface ITeleportData {
  status: string;
  redirect: {
    location: string;
    reason: string;
  };
  csrf: string;
}

/**
 * Сайт Литрес доступен на различных доменах, и иногда нужно переходить из одного в другой с сохранением авторизации (кроссавторизация).
 * Для такого перехода вызываем эту функцию.
 */
export async function redirectToUrlWithOneTimeSidAuthLogic({
  teleportData,
  getNewStackOneTimeSid,
  redirectionPathname = "/",
  redirectionSearchParams = new URLSearchParams(),
}: IRedirectToUrlWithOneTimeSidAuthLogicParams) {
  if (
    !teleportData ||
    (teleportData.status !== "ok" && !teleportData.redirect)
  ) {
    throw new Error("Incorrect teleport data");
  }

  const teleportLocation = new URL(teleportData.redirect.location);
  const teleportLocationParams = new URLSearchParams(teleportLocation.search);

  const redirectionUrl = new URL(
    `${teleportLocation.origin}${redirectionPathname}`
  );

  const resultSearchParams = new URLSearchParams(redirectionSearchParams);

  /**
   * У нас два различных query параметра, один для авторизации в страницах старого стека (Xportal), другой - нового стека (Next-app).
   * Так как данная утилита используется для страниц разного стека - вставляем оба параметра.
   */
  const oldStackOneTimeSid = teleportLocationParams.get("otsid") || "";
  const newStackOneTimeSid = await getNewStackOneTimeSid();

  resultSearchParams.set("otsid", oldStackOneTimeSid);
  resultSearchParams.set("nextauth", newStackOneTimeSid);
  redirectionUrl.search = resultSearchParams.toString();

  window.location.href = redirectionUrl.href;
}
